import { Box, Flex, Text } from '@modusign/design-system';
import { useDispatch, useSelector } from 'react-redux';

import { getParticipantAttachments } from '@app/store/contract-setup/selectors';
import { modalClose } from '@app/store/modal/actions';

function SigningRequestAttachmentModal() {
  const dispatch = useDispatch();
  const participantAttachmentsGroupedByParticipant = useSelector(getParticipantAttachments);
  const participantAttachments = participantAttachmentsGroupedByParticipant.flatMap(
    ({ participantId, participantName, requests }) =>
      requests.map((request) => ({ ...request, participantId, participantName }))
  );

  return (
    <div className="Container Container--max-xl">
      <div className="Card Card--pop WindowModal">
        <div className="WindowModal__header">
          <Box
            as="svg"
            fill="none"
            height="20"
            sx={{ float: 'left', mr: 2 }}
            viewBox="0 0 22 20"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1.5L2.35 11.15C0.55 12.95 0.55 15.88 2.35 17.69C4.15 19.49 7.08 19.49 8.89 17.69L19.79 6.79C20.99 5.59 20.99 3.64 19.79 2.44C18.59 1.24 16.64 1.24 15.44 2.44L4.62 13.26C4.02 13.86 4.02 14.83 4.62 15.44C5.22 16.04 6.19 16.04 6.8 15.44L16.4 5.84"
              stroke="#BDBDBD"
              strokeLinecap="square"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </Box>
          <h4 className="WindowModal__header-title">첨부파일 요청</h4>
          <button
            className="WindowModal__header-close-btn"
            type="button"
            onClick={() => {
              dispatch(modalClose());
            }}
          />
        </div>
        <Box sx={{ px: 4 }}>
          <Box sx={{ minWidth: '82px' }}>
            <Flex flexDirection="column">
              {participantAttachments.map(
                ({ attachmentType, message, participantId, participantName, required }, index) => (
                  <Flex
                    borderBottomColor="lightGray300"
                    borderBottomStyle="solid"
                    borderBottomWidth="1px"
                    flexDirection="column"
                    key={`${participantId}-${index}`} // eslint-disable-line react/no-array-index-key
                    lineHeight="21px"
                    pt={6}
                    px={3}
                    py={message ? 6 : 3}
                    sx={{
                      '&:last-of-type': {
                        borderBottomWidth: 0,
                      },
                    }}
                  >
                    <Flex justifyContent="space-between" mb={2}>
                      <Text
                        fontWeight="medium"
                        mb={2}
                        sx={{
                          minWidth: '184px',
                          mr: 4,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          '&::before': required ? { content: '"*"', color: 'red' } : {},
                        }}
                      >
                        {attachmentType}
                      </Text>
                      <Text
                        sx={{
                          color: 'textNeutralVeryLight',
                          minWidth: '78px',
                          overflow: 'hidden',
                          textAlign: 'right',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {participantName}
                      </Text>
                    </Flex>
                    <Text color="textNeutralLight">{message}</Text>
                  </Flex>
                )
              )}
            </Flex>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default SigningRequestAttachmentModal;
